import {IColumn, TooltipHost} from '@fluentui/react';
import {ColumnType} from '../IEnhancedDetailsList';
import {EnhancedColumn} from './EnhancedColumn';

export class BreakWordColumn extends EnhancedColumn {
  public static type = ColumnType.BreakWord;

  public static searchFunction(itemValue: string, lowerCaseSearch: string): boolean {
    return itemValue ? `${itemValue}`.toLowerCase().includes(lowerCaseSearch) : false;
  }

  public static renderer(value: string, column: IColumn, item?: any): JSX.Element {
    return (
      <TooltipHost
      content={item.title}>
        <div
          style={{
            cursor: 'help',
            width: '100%',
            overflow: 'hidden'
          }}>
          <span
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: '20px',
              maxHeight: '40px',
              paddingLeft: '20px',
              textIndent: '-20px'
            }}>
            {item.title}
          </span>
        </div>
      </TooltipHost>
    );
  }
}
